module.exports = __webpack_public_path__ + "img/203.ff6a5dad.png";